document.addEventListener("DOMContentLoaded", function () {
  let lastClicked = null;

  document.querySelectorAll('.animated-stories-link').forEach(function (el) {
    el.addEventListener('click', function (e) {
      const tooltip = el.querySelector('.tooltip-bubble');
      if (!tooltip) return;

      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        if (lastClicked === el && tooltip.classList.contains('visible')) {
          return; // 2e clic : laisse passer le lien
        }

        e.preventDefault(); // 1er clic mobile = bloque le lien
        document.querySelectorAll('.tooltip-bubble').forEach(tip => tip.classList.remove('visible'));
        tooltip.classList.add('visible');
        lastClicked = el;

        setTimeout(() => {
          tooltip.classList.remove('visible');
          lastClicked = null;
        }, 3000);
      }
      // Desktop : ne bloque pas, laisse le lien s’ouvrir normalement
    });
  });

  document.addEventListener('click', function (e) {
    const isIcon = e.target.closest('.animated-stories-link');
    if (!isIcon) {
      document.querySelectorAll('.tooltip-bubble.visible').forEach(function (tip) {
        tip.classList.remove('visible');
      });
      lastClicked = null;
    }
  });
});